import {
  Select,
  Row,
  Col,
  Card,
  Input,
  message,
  Form,
  Divider,
  Space,
  Button,
  InputNumber,
  DatePicker,
  Drawer,
} from "antd";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { DeleteOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { API_BASE_CRM_URL } from "../../Config/Config";
import Swal from "sweetalert2";

const AddEstimate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [productLoading, setProductLoading] = useState(false);
  const [userDetails, SetUserDetails] = useState([]);

  const [customers, setCustomers] = useState([]);
  const [products, setProducts] = useState([]);

  const [formData, setFormData] = useState({
    clientid: null,
    project_id: 0,
    number: "",
    prefix: "EST-",
    date: dayjs(), // Current Date
    expirydate: dayjs().add(30, "day"), // 30 days later
    billing_street: "",
    billing_city: "",
    billing_state: "",
    billing_zip: "",
    billing_country: 1,

    shipping_street: "",
    shipping_city: "",
    shipping_state: "",
    shipping_zip: "",
    shipping_country: 1,
    status: 1,
    clientnote: "",
    adminnote: "",
    terms: "",
    reference_no: "",
    sale_agent: null,
  });

  const [billingDrawerOpen, setBillingDrawerOpen] = useState(false);
  const [shippingDrawerOpen, setShippingDrawerOpen] = useState(false);

  const [billingTemp, setBillingTemp] = useState({});
  const [shippingTemp, setShippingTemp] = useState({});

  const [staffList, setStaffList] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  useEffect(() => {
    const userDetailsSession = JSON.parse(
      sessionStorage.getItem("userDetails"),
    );

    SetUserDetails(userDetailsSession);

    setFormData((prev) => ({
      ...prev,
      sale_agent: userDetailsSession?.staffid || null,
    }));
  }, []);

  const getStaffDropdown = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}staff/GetStaffDropdown`);

      const data = await response.json();

      if (data.Status) {
        setStaffList(data.ResultData || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getCustomers = async () => {
    try {
      const response = await fetch(`${API_BASE_CRM_URL}customers/GetCustomers`);

      const data = await response.json();

      setCustomers(data.ResultData || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCustomers();
    getProducts();
    getStaffDropdown();
  }, []);

  const getProducts = async () => {
    try {
      setProductLoading(true);

      const response = await fetch(`${API_BASE_CRM_URL}products/GetProducts`);

      const data = await response.json();

      setProducts(data.Data || []);
    } catch (error) {
      console.log(error);
    } finally {
      setProductLoading(false);
    }
  };

  const handleCustomerChange = async (customerId) => {
    try {
      setCustomerLoading(true);

      const response = await fetch(
        `${API_BASE_CRM_URL}customers/GetCustomerDetails?CusId=${customerId}`,
      );

      const data = await response.json();

      if (data.Status && data.ResultData?.length) {
        const customer = data.ResultData[0];

        setFormData((prev) => ({
          ...prev,
          clientid: customer.customerId,

          billing_street: customer.billing_street || customer.address || "",
          billing_city: customer.billing_city || customer.city || "",
          billing_state: customer.billing_state || customer.state || "",
          billing_zip: customer.billing_zip || customer.zip || "",
          billing_country: customer.country || 1,

          shipping_street: customer.shipping_street || customer.address || "",
          shipping_city: customer.shipping_city || customer.city || "",
          shipping_state: customer.shipping_state || customer.state || "",
          shipping_zip: customer.shipping_zip || customer.zip || "",
          shipping_country: customer.country || 1,
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setCustomerLoading(false);
    }
  };

  const handleProductSelect = (productId) => {
    const product = products.find((p) => p.id === productId);

    if (!product) return;

    const alreadyExists = selectedItems.some(
      (item) => item.item_id === product.id,
    );

    if (alreadyExists) return;

    setSelectedItems((prev) => [
      ...prev,
      {
        item_id: product.id,
        description: product.description,
        long_description: product.long_description,
        qty: 1,
        rate: Number(product.rate),
        tax: Number(product.tax || 0),
        unit: product.unit,
      },
    ]);
  };

  const updateQty = (index, qty) => {
    const items = [...selectedItems];

    items[index].qty = qty <= 0 ? 1 : qty;

    setSelectedItems(items);
  };

  const removeItem = (index) => {
    const items = [...selectedItems];

    items.splice(index, 1);

    setSelectedItems(items);
  };

  const subtotal = selectedItems.reduce(
    (sum, item) => sum + item.qty * item.rate,
    0,
  );

  const totalTax = selectedItems.reduce(
    (sum, item) => sum + item.qty * item.rate * (item.tax / 100),
    0,
  );

  const total = subtotal + totalTax;

  const openBillingDrawer = () => {
    setBillingTemp({
      billing_street: formData.billing_street,
      billing_city: formData.billing_city,
      billing_state: formData.billing_state,
      billing_zip: formData.billing_zip,
    });

    setBillingDrawerOpen(true);
  };

  const openShippingDrawer = () => {
    setShippingTemp({
      shipping_street: formData.shipping_street,
      shipping_city: formData.shipping_city,
      shipping_state: formData.shipping_state,
      shipping_zip: formData.shipping_zip,
    });

    setShippingDrawerOpen(true);
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const payload = {
        clientid: formData.clientid,
        project_id: 0,
        number: Number(formData.number),
        prefix: formData.prefix,
        date: formData.date.format("YYYY-MM-DD"),
        expirydate: formData.expirydate.format("YYYY-MM-DD"),

        currency: 1,

        subtotal,
        total_tax: totalTax,
        total,

        adjustment: 0,
        addedfrom: 49,
        status: formData.status,

        clientnote: formData.clientnote,
        adminnote: formData.adminnote,

        discount_percent: 0,
        discount_total: 0,
        discount_type: "",

        terms: formData.terms,
        reference_no: formData.reference_no,
        sale_agent: 49,

        billing_street: formData.billing_street,
        billing_city: formData.billing_city,
        billing_state: formData.billing_state,
        billing_zip: formData.billing_zip,
        billing_country: formData.billing_country,

        shipping_street: formData.shipping_street,
        shipping_city: formData.shipping_city,
        shipping_state: formData.shipping_state,
        shipping_zip: formData.shipping_zip,
        shipping_country: formData.shipping_country,

        items: selectedItems.map((item) => ({
          item_id: item.item_id,
          description: item.description,
          long_description: item.long_description,
          qty: item.qty,
          rate: item.rate,
          unit: item.unit,
        })),
      };

      const response = await fetch(`${API_BASE_CRM_URL}estimates/AddEstimate`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.Status) {
        await Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1000,
          showConfirmButton: false,
        });

        navigate("/estimates");
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Base>
      <div className="row align-items-center mb-2">
        <div className="col-8">
          <div className="page-title">
            <h4>Add Estimate</h4>
          </div>
        </div>
        <div className="col-4 d-flex justify-content-end">
          <Link to="/estimates">
            <button className="btn btn-sm btn-secondary">
              <i className="fa-solid fa-list"></i>
            </button>
          </Link>
        </div>
      </div>
      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <div className="row g-2">
            <div className="col-6">
              <Select
                showSearch
                className="w-100"
                placeholder="Select Customer"
                onChange={handleCustomerChange}
                options={customers.map((customer) => ({
                  value: customer.customerId,
                  label: customer.company,
                }))}
              />
            </div>
            <div className="col-6">
              <Select
                className="w-100"
                value={formData.status}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    status: value,
                  })
                }
                options={[
                  {
                    label: "Draft",
                    value: 1,
                  },
                  {
                    label: "Sent",
                    value: 2,
                  },
                  {
                    label: "Expired",
                    value: 3,
                  },
                  {
                    label: "Declined",
                    value: 4,
                  },
                  {
                    label: "Accepted",
                    value: 5,
                  },
                ]}
              />
            </div>
            <div className="col-6">
              <Input
                size="large"
                addonBefore={<span className="fw-bold text-primary">EST</span>}
                placeholder="Estimate Number"
                value={formData.number}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    number: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-6">
              <DatePicker
                size="large"
                className="w-100"
                format="DD-MM-YYYY"
                value={formData.date}
                onChange={(value) =>
                  setFormData({
                    ...formData,
                    date: value,
                  })
                }
              />
            </div>
            <div className="col-6">
              <DatePicker
                size="large"
                className="w-100"
                value={formData.expirydate}
                disabledDate={(current) =>
                  current && current.isBefore(formData.date.startOf("day"))
                }
              />
            </div>
            <div className="col-6">
              <Select
                className="w-100"
                placeholder="Select Sale Agent"
                value={formData.sale_agent}
                onChange={(value) =>
                  setFormData((prev) => ({
                    ...prev,
                    sale_agent: value,
                  }))
                }
                options={staffList.map((staff) => ({
                  value: staff.staffid,
                  label: `${staff.firstname} ${staff.lastname}`,
                }))}
                // suffixIcon={<i className="fas fa-user-tie"></i>}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 mb-2">
        <div className="card-header bg-white d-flex justify-content-between align-items-center py-1">
          <strong>
            <i className="fas fa-map-marker-alt text-success me-2"></i>
            Billing Address
          </strong>

          <Button
            type="text"
            icon={<i className="fas fa-edit text-primary"></i>}
            onClick={openBillingDrawer}
          />
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-6 mb-2">
              <i className="fas fa-road me-2 text-secondary"></i>
              {formData.billing_street || "-"}
            </div>

            <div className="col-6 mb-2">
              <i className="fas fa-city me-2 text-secondary"></i>
              {formData.billing_city || "-"}
            </div>

            <div className="col-6 mb-2">
              <i className="fas fa-map me-2 text-secondary"></i>
              {formData.billing_state || "-"}
            </div>

            <div className="col-6 mb-2">
              <i className="fas fa-mail-bulk me-2 text-secondary"></i>
              {formData.billing_zip || "-"}
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 mb-2">
        <div className="card-header bg-white d-flex justify-content-between align-items-center py-1">
          <strong>
            <i className="fas fa-shipping-fast text-warning me-2"></i>
            Shipping Address
          </strong>

          <Button
            type="text"
            icon={<i className="fas fa-edit text-primary"></i>}
            onClick={openShippingDrawer}
          />
        </div>

        <div className="card-body">
          <div className="row">
            <div className="col-6 mb-2">
              <i className="fas fa-road me-2 text-secondary"></i>
              {formData.shipping_street || "-"}
            </div>

            <div className="col-6 mb-2">
              <i className="fas fa-city me-2 text-secondary"></i>
              {formData.shipping_city || "-"}
            </div>

            <div className="col-6 mb-2">
              <i className="fas fa-map me-2 text-secondary"></i>
              {formData.shipping_state || "-"}
            </div>

            <div className="col-6 mb-2">
              <i className="fas fa-mail-bulk me-2 text-secondary"></i>
              {formData.shipping_zip || "-"}
            </div>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 mb-3">
        <div className="card-body">
          <strong className="mb-1">
            <i className="fas fa-box me-2 text-warning"></i>
            Products
          </strong>
          <Select
            showSearch
            size="large"
            className="w-100"
            placeholder="Select Product"
            onChange={handleProductSelect}
            options={products.map((product) => ({
              value: product.id,
              label: product.description,
            }))}
          />
        </div>
      </div>

      {selectedItems.map((item, index) => {
        const amount = item.qty * item.rate;
        const taxAmount = amount * (item.tax / 100);

        return (
          <div key={item.item_id} className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              {/* Header */}

              <div className="d-flex justify-content-between align-items-start mb-1">
                <div>
                  <h5 className="mb-1 fw-semibold">{item.description}</h5>
                </div>

                <Button
                  danger
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => removeItem(index)}
                />
              </div>

              {/* Qty */}

              <div className="d-flex justify-content-between align-items-center mb-1">
                <span className="fw-medium">Quantity</span>

                <div className="input-group" style={{ width: 130 }}>
                  <button
                    className="btn btn-light border"
                    type="button"
                    onClick={() => updateQty(index, Math.max(1, item.qty - 1))}
                  >
                    <i className="fas fa-minus"></i>
                  </button>

                  <input
                    className="form-control text-center"
                    value={item.qty}
                    readOnly
                  />

                  <button
                    className="btn btn-light border"
                    type="button"
                    onClick={() => updateQty(index, item.qty + 1)}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>

              <hr className="m-1" />

              {/* Summary */}

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Rate</span>

                <span className="fw-medium">₹ {item.rate}</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Tax</span>

                <span className="fw-medium">{item.tax}%</span>
              </div>

              <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Subtotal</span>

                <span className="fw-medium">₹ {amount.toFixed(2)}</span>
              </div>

              <div className="d-flex justify-content-between">
                <span className="fw-semibold">Total</span>

                <span className="fw-bold text-success">
                  ₹ {(amount + taxAmount).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        );
      })}

      <div className="card border-0 shadow-sm">
        <div className="card-body">
          <div className="d-flex justify-content-between mb-2">
            <span>Subtotal</span>
            <strong>₹ {subtotal.toFixed(2)}</strong>
          </div>

          <div className="d-flex justify-content-between mb-2">
            <span>Tax</span>
            <strong>₹ {totalTax.toFixed(2)}</strong>
          </div>

          <hr />

          <div className="d-flex justify-content-between">
            <h5>Total</h5>
            <h5 className="text-success">₹ {total.toFixed(2)}</h5>
          </div>
        </div>
      </div>

      <div className="card shadow-sm border-0 mb-3">
        <div className="card-header bg-white">
          <strong>
            <i className="fas fa-user-edit me-2 text-primary"></i>
            Client Note
          </strong>
        </div>

        <div className="card-body">
          <Input.TextArea
            rows={4}
            placeholder="Visible to customer"
            value={formData.clientnote}
            onChange={(e) =>
              setFormData({
                ...formData,
                clientnote: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-secondary btn-sm mt-3"
          onClick={handleSubmit}
          type="button"
          disabled={loading}
        >
          {loading ? (
            <>
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
              />
              Saving...
            </>
          ) : (
            <>
              <i className="fas fa-save me-2"></i>
              Save
            </>
          )}
        </button>
      </div>

      <Drawer
        title={
          <>
            <i className="fas fa-map-marker-alt text-success me-2"></i>
            Edit Billing Address
          </>
        }
        placement="bottom"
        height="45%"
        open={billingDrawerOpen}
        onClose={() => setBillingDrawerOpen(false)}
        closeIcon={false}
        extra={
          <Space>
            <Button
              icon={<CloseOutlined />}
              onClick={() => setBillingDrawerOpen(false)}
            />

            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => {
                setFormData((prev) => ({
                  ...prev,
                  ...billingTemp,
                }));

                setBillingDrawerOpen(false);
              }}
            />
          </Space>
        }
      >
        <div className="row">
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Street"
              prefix={<i className="fas fa-road text-muted" />}
              value={billingTemp.billing_street}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_street: e.target.value,
                })
              }
            />
          </div>
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="City"
              prefix={<i className="fas fa-city text-muted" />}
              value={billingTemp.billing_city}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_city: e.target.value,
                })
              }
            />
          </div>
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="State"
              prefix={<i className="fas fa-map-marked-alt text-muted" />}
              value={billingTemp.billing_state}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_state: e.target.value,
                })
              }
            />
          </div>

          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Zip Code"
              prefix={<i className="fas fa-mail-bulk text-muted" />}
              value={billingTemp.billing_zip}
              onChange={(e) =>
                setBillingTemp({
                  ...billingTemp,
                  billing_zip: e.target.value,
                })
              }
            />
          </div>
        </div>
      </Drawer>

      <Drawer
        title={
          <>
            <i className="fas fa-shipping-fast text-warning me-2"></i>
            Edit Shipping Address
          </>
        }
        closeIcon={false}
        placement="bottom"
        height="45%"
        open={shippingDrawerOpen}
        onClose={() => setShippingDrawerOpen(false)}
        extra={
          <Space>
            <Button
              icon={<CloseOutlined />}
              onClick={() => setShippingDrawerOpen(false)}
            />

            <Button
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => {
                setFormData((prev) => ({
                  ...prev,
                  ...shippingTemp,
                }));

                setShippingDrawerOpen(false);
              }}
            />
          </Space>
        }
      >
        <div className="row">
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Street"
              prefix={<i className="fas fa-road text-muted" />}
              value={shippingTemp.shipping_street}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_street: e.target.value,
                })
              }
            />
          </div>

          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="City"
              prefix={<i className="fas fa-city text-muted" />}
              value={shippingTemp.shipping_city}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_city: e.target.value,
                })
              }
            />
          </div>
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="State"
              prefix={<i className="fas fa-map-marked-alt text-muted" />}
              value={shippingTemp.shipping_state}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_state: e.target.value,
                })
              }
            />
          </div>
          <div className="col-6">
            <Input
              size="large"
              className="mb-3"
              placeholder="Zip"
              prefix={<i className="fas fa-map-marked-alt text-muted" />}
              value={shippingTemp.shipping_zip}
              onChange={(e) =>
                setShippingTemp({
                  ...shippingTemp,
                  shipping_zip: e.target.value,
                })
              }
            />
          </div>
        </div>
      </Drawer>
      <Footer />
    </Base>
  );
};

export default AddEstimate;
